import Vue from 'vue';

// 组件生成的dom节点挂载到body上
export function create(Component: any, props: any, el: any, next?: any) {
  // 借助Vue来create real dom 然后添加到body中
  const instance = new Vue({
    render(h) {
      return h(Component, { props });
    },
  }).$mount();
  const comp: any = instance.$children[0];
  // insertBefore
  if (next === 'bottom') {
    el.appendChild(instance.$el);
    comp.remove = function() {
      // 从body中移除
      el.removeChild(instance.$el);
      instance.$destroy(); //将vue 的实例对象销毁
    };
  }

  if (next === 'top') {
    const elTopParent = el.parentNode.parentNode;
    const elParent = el.parentNode;
    elTopParent.insertBefore(instance.$el, elParent);
    comp.remove = function() {
      // 从body中移除
      elTopParent.removeChild(instance.$el);
      instance.$destroy(); //将vue 的实例对象销毁
    };
  }

  return comp;
}
